<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconMeetingRoom_24"
>
    <path
        d="M18.875 5H5.125A3.128 3.128 0 0 0 2 8.125v8.75A3.128 3.128 0 0 0 5.125 20h13.75A3.128 3.128 0 0 0 22 16.875v-8.75A3.128 3.128 0 0 0 18.875 5ZM12 7.984a2.879 2.879 0 0 1 2.876 2.875A2.879 2.879 0 0 1 12 13.735a2.879 2.879 0 0 1-2.876-2.876A2.878 2.878 0 0 1 12 7.984Zm4.636 10.766H7.364a.785.785 0 0 1-.775-.9c.141-.902.483-1.25.683-1.468.745-.813 2.161-1.419 4.728-1.419 2.545 0 3.959.596 4.709 1.398.216.231.561.585.702 1.488a.785.785 0 0 1-.775.901Z"
        fill="currentColor"
    />
</svg>
